//#region getPoolTicks
import { z } from "zod"

import { ethereumAddress } from "../base"

const manualClPoolTickItem = z.object({
  id: z.string(),
  // `Tick.poolAddress` in the Envio HyperIndex schema is the composite pool
  // ID (`<address>-<chainId>`), not a bare EVM address. Validating it with
  // `ethereumAddress` silently fails the entire schema parse and manifests
  // as "Liquidity · No data" in the range-brush, so we accept the raw string
  // here. Consumers that need the bare address read `pool.address` below.
  poolAddress: z.string(),
  tickIdx: z.string(),
  chainId: z.union([z.string(), z.number()]).transform((val) => {
    const num = typeof val === "string" ? Number(val) : val
    if (isNaN(num)) throw new Error(`Invalid chainId: ${val}`)
    return num
  }),
  pool: z.object({
    id: z.string(),
    address: ethereumAddress,
  }),
  liquidityGross: z.string(),
  liquidityNet: z.string(),
  price0: z.union([z.string(), z.number()]).transform((val) => {
    const num = typeof val === "string" ? Number(val) : val
    if (isNaN(num)) throw new Error(`Invalid price0: ${val}`)
    return num
  }),
  price1: z.union([z.string(), z.number()]).transform((val) => {
    const num = typeof val === "string" ? Number(val) : val
    if (isNaN(num)) throw new Error(`Invalid price1: ${val}`)
    return num
  }),
  createdAtTimestamp: z.union([z.string(), z.number()]).transform((val) => {
    const num = typeof val === "string" ? Number(val) : val
    if (isNaN(num)) throw new Error(`Invalid createdAtTimestamp: ${val}`)
    return num
  }),
  createdAtBlockNumber: z.union([z.string(), z.number()]).transform((val) => {
    const num = typeof val === "string" ? Number(val) : val
    if (isNaN(num)) throw new Error(`Invalid createdAtBlockNumber: ${val}`)
    return num
  }),
})

const manualClPoolTicks = z
  .object({
    Tick: z.array(manualClPoolTickItem),
  })
  .transform((data) => ({
    ticks: data.Tick,
  }))

export const manualClPoolTicksResponseSchema = manualClPoolTicks

export type ManualClPoolTicksResponse = z.infer<typeof manualClPoolTicksResponseSchema>
export type ManualClPoolTicksResponseItem = z.infer<typeof manualClPoolTickItem>
//#endregion
